import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import {CareerState} from './CareerState'
import { DashboardState } from './DashboardState';
import { JobListState } from './JobListState';
import { JobPostList } from './JobPostList';
import { ApListState } from './ApListState';
import { ApplicantsState } from './ApplicantsState';
import { OnboardXState } from './OnboardXState';
import { JobPost } from './JobPost';
import { ProfileState } from './ProfileState';
import { UsageOverviewState } from './UsageOverviewState';


export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
        career_state: CareerState(),
        dashboard_state: DashboardState(),
        joblist_state: JobListState(),
        JobPostList_state: JobPostList(),
        apList_state: ApListState(),
        applicants_state:ApplicantsState(),
        onboardx_state:OnboardXState(),
        jobpost_state:JobPost(),
        profile_state:ProfileState(),
        usage_state:UsageOverviewState()
   
    }
}